/**
 * Cookie names are prefixed per environment (dev_/staging_/local_) on the backend
 * so developers can authenticate against multiple environments in the same browser
 * without cross-env cookie-name collisions. Production uses no prefix.
 *
 * VITE_COOKIE_PREFIX must match app.cookie.name-prefix in the corresponding backend
 * profile yaml.
 */
const COOKIE_PREFIX: string = import.meta.env.VITE_COOKIE_PREFIX || ''

function getCsrfCookieName(): string {
  return `${COOKIE_PREFIX}XSRF-TOKEN`
}

export function getCsrfTokenFromCookie(): string | null {
  const name = `${getCsrfCookieName()}=`
  const cookies = document.cookie.split(';')
  for (const cookie of cookies) {
    const trimmed = cookie.trim()
    if (trimmed.indexOf(name) === 0) {
      return decodeURIComponent(trimmed.substring(name.length))
    }
  }
  return null
}
